<template>
  <!-- Notas Orientativas -->
  <section class="py-5" id="notas-orientativas">
    <div class="container-fluid text-center">
      <div class="row align-items-center justify-content-center bg-aquamarine" style="height:15vh;">
        <div class="col-md-12">
          <h1 class="text-white">NOTAS ORIENTATIVAS</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 bg-light">
          <p>Separamos aqui, alguns links rápidos para facilitar a sua busca pela informação, aproveite para salvar as notas e compartilhar com outras pessoas.</p>
        </div>
        <div class="col-lg-4 animate-in-left">
          <a href="https://www.toledo.pr.gov.br/sites/default/files/nota_orientativa_-_coronavirus_-_academias.pdf"
             class="btn btn-outline-primary btn-lg m-2" style="width:100%">
            <h3 class="mb-0"><b>Academias</b></h3>
          </a>
        </div>
        <div class="col-lg-4">
          <a href="https://www.toledo.pr.gov.br/sites/default/files/agencias_bancarias_-_atualizado_em_14-07-2020.pdf" class="btn btn-outline-primary btn-lg m-2" style="width:100%">
            <h3 class="mb-0"><b>Agências Bancárias</b></h3>
          </a>
        </div>
        <div class="col-lg-4 animate-in-right">
          <a href="https://www.toledo.pr.gov.br/sites/default/files/nota_orientativa_-_coronavirus_-_casas_lotericas.pdf" class="btn btn-outline-primary btn-lg m-2" style="width:100%">
            <h3 class="mb-0"><b>Casas Lotéricas</b></h3>
          </a>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4 animate-in-left">
          <a href="https://www.toledo.pr.gov.br/sites/default/files/nota_orientativa_-_coronavirus_-_comercio_em_geral.pdf" class="btn btn-outline-primary btn-lg m-2" style="width:100%">
            <h3 class="mb-0"><b>Comércio em Geral</b></h3>
          </a>
        </div>
        <div class="col-lg-4">
          <a href="https://www.toledo.pr.gov.br/sites/default/files/nota_orientativa_-_coronavirus_-_cuidados_no_domicilio.pdf" class="btn btn-outline-primary btn-lg m-2" style="width:100%">
            <h3 class="mb-0"><b>Cuidados no Domicílio</b></h3>
          </a>
        </div>
        <div class="col-lg-4 animate-in-right">
          <a href="https://www.toledo.pr.gov.br/sites/default/files/nota_orientativa_-_coronavirus_-_delivery_de_alimentos.pdf" class="btn btn-outline-primary btn-lg m-2" style="width:100%">
            <h3 class="mb-0"><b>Delivery de Alimentos</b></h3>
          </a>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4 animate-in-left">
          <a href="https://www.toledo.pr.gov.br/sites/default/files/nota_orientativa_-_coronavirus_-_feiras_do_pequeno_produtor.pdf" class="btn btn-outline-primary btn-lg m-2" style="width:100%">
            <h3 class="mb-0"><b>Feiras do Produtor</b></h3>
          </a>
        </div>
        <div class="col-lg-4">
          <a href="https://www.toledo.pr.gov.br/sites/default/files/nota_orientativa_-_coronavirus_-_mercados.pdf" class="btn btn-outline-primary btn-lg m-2" style="width:100%">
            <h3 class="mb-0"><b>Supermercados</b></h3>
          </a>
        </div>
        <div class="col-lg-4 animate-in-right">
          <a href="https://www.toledo.pr.gov.br/sites/default/files/nota_orientativa_-_coronavirus_-_servicos_de_alimentacao.pdf" class="btn btn-outline-primary btn-lg m-2" style="width:100%">
            <h3 class="mb-0"><b>Serviços de Alimentação</b></h3>
          </a>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4 animate-in-left">
          <a href="https://www.toledo.pr.gov.br/sites/default/files/nota_orientativa_-_coronavirus_-_saloes_de_beleza.pdf" class="btn btn-outline-primary btn-lg m-2" style="width:100%">
            <h3 class="mb-0"><b>Salões de Beleza</b></h3>
          </a>
        </div>
        <div class="col-lg-4">
          <a href="https://www.toledo.pr.gov.br/sites/default/files/nota_orientativa_-_coronavirus_-_servicos_de_saude_-_v2.pdf" class="btn btn-outline-primary btn-lg m-2" style="width:100%">
            <h3 class="mb-0"><b>Serviços de Saúde</b></h3>
          </a>
        </div>
        <div class="col-lg-4 animate-in-right">
          <a href="https://www.toledo.pr.gov.br/sites/default/files/nota_orientativa_-_coronavirus_-_shopping_centers.pdf" class="btn btn-outline-primary btn-lg m-2" style="width:100%">
            <h3 class="mb-0"><b>Shopping Centers</b></h3>
          </a>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4 animate-in-left">
          <a href="https://www.toledo.pr.gov.br/sites/default/files/colacao_de_grau.pdf" class="btn btn-outline-primary btn-lg m-2" style="width:100%">
            <h3 class="mb-0"><b>Colação de Grau</b></h3>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
name: "Bloco6NotasOrientativas"
}
</script>

<style scoped>
.btn-outline-primary {
  color: #12bbad;
  background-color: transparent;
  background-image: none;
  border-color: #12bbad; }
.btn-outline-primary:hover {
  color: #fff;
  background-color: #12bbad;
  border-color: #12bbad; }
.btn-outline-primary:focus, .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(18, 187, 173, 0.5); }
.btn-outline-primary.disabled, .btn-outline-primary:disabled {
  color: #12bbad;
  background-color: transparent; }
/*.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .btn-outline-primary.dropdown-toggle {
  color: #fff;
  background-color: #12bbad;
  border-color: #12bbad; }*/
/*.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(18, 187, 173, 0.5); }*/

</style>